import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SUBSCRIBE_TEMPLATE } from "../../../actions/types";
import ContactForm from "../../help/ContactForm";
import BotRentCryptoPayment from "../subscription/BotRentCryptoPayment";
import { RentSubscriptions, SUB_TIER } from "../../../Const";
import RentCheckboxCard from "./RentCheckboxCard";
import { marketplaceTerms } from "../../../actions/const";
import { Trans } from "react-i18next";
import { checkSub, isPremium } from "../../../utils/SubUtils";

const TemplateRentDetails = (props)=>{
    const {template,monthly,t}=props
    const [loading, setLoading] = useState(false);
    const [showCryptoPayment, setShowCryptoPayment] = useState(false);
    const [network, setNetwork] = useState('ERC');
    const [showContactForm, setShowContactForm] = useState(false);
    const [paymentType, setPaymentType] = useState(null);
    const [amount, setAmount] = useState(0);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const subscription =
    useSelector((state) => state.auth.user.user_subscription) || {};
    const { subPremium, subTier } = checkSub(subscription);
    const isPaid = isPremium(subscription);
    const history = useHistory();
    const dispatch = useDispatch();
    const clickUpgrade = () => {
        // dispatch({
        //     type: SUBSCRIBE_TEMPLATE,
        //     payload: template,
        //   });
        // history.push(
        //   "/bot-subscription?plan="+paymentType 
        // );
        if(isPaid && subTier != SUB_TIER.lite){
            dispatch({
                type: SUBSCRIBE_TEMPLATE,
                payload: template,
              });
            history.push(
              "/bot-subscription?plan="+paymentType 
            );
        }
        else{
            history.push(
                "/setting?loc=2"
              );
        }
    };
    
    useEffect(()=>{
        setAmount(template.yearly_fee)
        setPaymentType('yearly')
    },[template])
    // const showCryptoPaymentModal = (network,qr,address)=>{
        
    //     if (!agreeTerms || parseInt(amount) <= 0){
    //         return false
    //     }
    //     setNetwork(network)
    //     setShowCryptoPayment(true)
    //   }
    const clickPaymentType = (amount,type)=>{
        setPaymentType(type)
        setAmount(amount)
      }
    const rentPlans = (
        <>
         {Object.keys(RentSubscriptions).map((planName,key)=>(
            <RentCheckboxCard planName={planName} plan={RentSubscriptions[planName]} template={template} clickPaymentType={clickPaymentType} paymentType={paymentType} key={key} t={t}></RentCheckboxCard>
         )  
        )}
        </>
       
       
    );
    return (
        <>
            <div className="round-bg mt-3">
            <Row className="center-align">
                <Col xs={12} className="no-padding">
                    
                    <Col xs={12}>
                        <h5>{t("rent-this-bot")}</h5>
                    </Col>
                    <Col xs={12} className="mt-4">
                        {rentPlans}
                        <div className="flex-vertical-center agree-rent-terms">
                            <Form.Check
                                label={
                                <Trans i18nKey={"rent-descl"}>
                                    <a href={marketplaceTerms} target="_blank"></a>
                                </Trans>
                                }
                                className="terms"
                                value={true}
                                onChange={(e) => setAgreeTerms(e.target.checked)}
                            />
                        </div>
                        <Button
                            style={{ marginTop: 10, width: "100%" }}
                            className={`py-2`}
                            variant="success"
                            onClick={() => clickUpgrade()}
                            disabled={!agreeTerms}>
                            {t("rent-this-bot")}
                        </Button>
                    </Col>
                    
                   
                </Col>
            </Row>
            <BotRentCryptoPayment
                show={showCryptoPayment}
                monthly={monthly}
                paymentType={paymentType}
                template={template}
                amount={amount}
                network={network}
                onHide={() => setShowCryptoPayment(false)}
                sendEmail={() => setShowContactForm(true)}
            />
            </div>
            <ContactForm
                show={showContactForm}
                onHide={() => setShowContactForm(false)}
            />
        </>
    );
}
export default connect(null,{})(TemplateRentDetails)